// import logo from './logo.svg';
import './App.css';
import 'semantic-ui-css/semantic.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

// import createRoutes from './routes/routes';
import CreateRoutes from './routes/routes';

function App() {
  // var hours = 1; // to clear the localStorage after 1 hour
  // (if someone want to clear after 8hrs simply change hours=8)
  var now = new Date().getTime();
  var setupTime = JSON.parse(localStorage.getItem('setupTime'));
  if (setupTime != null) {
    // if(now-setupTime > hours*60*60*1000) {
    if(now-setupTime > 20*60*1000) {
      localStorage.clear()
    }
  }

  // const routes = createRoutes();

  // return (
  //   routes
  // );

  return (
    <CreateRoutes/>
  );
}

export default App;
